import React from "react";
import { Link } from "react-router-dom";

import { generateUUID } from "../../services/utils";
import { ChevronLeftIcon } from "../../containers/HomePage/ChevronLeftIcon";
import styles from "./styles/BreadcrumbBar.scss";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import { selectCategories } from "../../containers/App/selectors";
import history from "../../history";
import useHrPageName from "../../utils/useHrPageName";

export interface IBreadcrumbBarProps {
  className?: string;
  routeLinks: any[];
  category: string;
  categories: any;
  backDisabled?: boolean;
}

function BreadcrumbBar(props: IBreadcrumbBarProps) {
  const { className, routeLinks, category, categories, backDisabled } = props;
  const hrPageName = useHrPageName(category);
  return (
    <div className={`${className} ${styles.breadcrumb}`}>
      {backDisabled || (<span
        className={styles.backButton}
        role="button"
        tabIndex={0}
        onClick={() => {
          ReactGA.event({
            category: "Detalji oglasa",
            action: "Click",
            label: `Dugme Natrag - ${hrPageName}`
          });
          history.goBack();
        }}
      >
        <ChevronLeftIcon className={styles.chevron} />
        <span>{"Natrag"}</span>
      </span>)}

      <span className={styles.div} />
      <Link
        onClick={() => {
          ReactGA.event({
            category: "Detalji oglasa",
            action: "Click",
            label: `Breadcrumbs - ${hrPageName}`
          });
        }}
        to="/"
      >
        {"Početna"}
      </Link>
      {routeLinks.map((r: any) => (
        <React.Fragment key={generateUUID()}>
          <span className={styles.dot}>・</span>
          {!r.link ? (
            <a>{r.title}</a>
          ) : (
            <Link
              onClick={() => {
                ReactGA.event({
                  category: "Detalji oglasa",
                  action: "Click",
                  label: `Breadcrumbs - ${hrPageName}`
                });
              }}
              to={r.link}
            >
              <p style={{ margin: "0" }}>{r.title}</p>
            </Link>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

BreadcrumbBar.defaultProps = {
  routeLinks: [],
  className: "",
  backDisabled: false,
};

export default connect(
  state => ({ categories: selectCategories(state) }),
  null
)(BreadcrumbBar);



// WEBPACK FOOTER //
// ./src/components/BreadcrumbBar/index.tsx